import { type FC } from 'react';
import { Navigate, useLocation } from 'react-router';
import { buildPathWithRedirect } from '@link/share/utils';
import { forwardGa4AccountEntry } from '@link/share/vendors';

/**
 * Sends a logged-out visitor of a private route to login, with the full path
 * as the return target. Of the navigation state only the GA4 account-flow
 * entry (e.g. the checkout gate) comes along.
 */
const RedirectToLogin: FC = () => {
  const { pathname, search, state } = useLocation();

  return (
    <Navigate
      to={buildPathWithRedirect('login', pathname + search)}
      state={forwardGa4AccountEntry(state)}
      replace
    />
  );
};

export default RedirectToLogin;
